// src/pages/DriverResetPassword.jsx
import React, { useState } from "react";
import axios from "axios";
import { useLocation, Link, useNavigate } from "react-router-dom";
import "./Dashboard.css"; // reuse card + btn styles
import api from "../utils/api";


export default function DriverResetPassword() {
  const query = new URLSearchParams(useLocation().search);
  const emailFromQuery = query.get("email") || "";
  const tokenFromQuery = query.get("token") || "";

  const [email, setEmail] = useState(emailFromQuery);
  const [token, setToken] = useState(tokenFromQuery);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setErr("");

    if (password.length < 6) {
      setErr("Password must be at least 6 characters");
      return;
    }
    if (password !== confirm) {
      setErr("Passwords do not match");
      return;
    }

    try {
      setSubmitting(true);
      const res = await api.post( "/driver/auth/reset-password", {
        email,
        token,
        password,
      });
      if (res.data.ok) {
        setMsg("✅ Password updated. Redirecting to login…");
        setTimeout(() => navigate("/driver/login"), 2000);
      } else {
        setErr(res.data.error || "Failed to reset password");
      }
    } catch (e) {
      setErr(e.response?.data?.error || "Reset failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page center-wrap">
      {msg && <div className="toast">{msg}</div>}
      {err && <div className="toast error">{err}</div>}

      <section className="card" style={{ maxWidth: 420, margin: "2rem auto" }}>
        <h2>Reset Driver Password</h2>
        <form onSubmit={onSubmit} className="add-form" noValidate>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>New Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="••••••••"
          />

          <label>Confirm Password</label>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            placeholder="••••••••"
          />

          <input type="hidden" value={token} readOnly />

          <button className="btn" type="submit" disabled={submitting}>
            {submitting ? "Resetting…" : "Reset Password"}
          </button>
        </form>

        <div style={{ marginTop: "1rem" }}>
          <Link to="/driver/login" className="muted">
            ← Back to login
          </Link>
        </div>
      </section>
    </div>
  );
}

